module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            COVID-19\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('p', [_vm._v("\n            Situationen omkring Corona-virus udvikler sig hele tiden og hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø følger vi udviklingen nøje.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vi er opmærksomme på smittefaren og ved, at vi har et særligt ansvar i at finde løsninger og drage omsorg for både kunder og personale.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Vores chauffører har derfor fået klare retningslinjer for, hvordan vi ved læsning / losning agerer for at minimere og reducere smitterisikoen.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Alle vores biler har naturligvis håndsprit i førerhuset. \n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61cc9e96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/covid.vue
// module id = 266
// module chunks = 1